import { putPromise } from "./request-promise";
import { FineGoalDataInterface, FineGoalParams } from "@app/models/chart-data.model";

export interface FineGoalResponse {
	data: FineGoalDataInterface[];
	message: string;
}

export interface FineGoalUpdateParams {
	siteId: number;
	goalArray?: FineGoalParams['goalArray'];
}

// TODO
export function updateFragSizeRangeFineGoals(fragSizeRangeFineGoalParams: FineGoalUpdateParams) {
	return putPromise<FineGoalResponse, FineGoalResponse>(
		'/api/dashboards/highchart_analytics/update_fines_goal',
		fragSizeRangeFineGoalParams,
		(data) => data || null
	);
}
